import React from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useState } from "react";
import { MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";

const MenuItems = ({ item, handleDeleteProduct }) => {
  const [anchorEl, setAnchorEl] = useState("");
  const navigate = useNavigate();

  const options = [
    {
      title: "View",
      value: 0,
    },
    {
      title: "Edit",
      value: 1,
    },
    {
      title: "Delete",
      value: 2,
    },
  ];
  const ITEM_HEIGHT = 48;

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleActionClick = (event, id) => {
    const { myValue } = event.currentTarget.dataset;
    if (myValue == 0) {
      navigate(`/product/${id}/${item.category.name}?view_all=false`);
    }
    if (myValue == 2) {
      handleDeleteProduct(id);
    } else if (myValue == 1) {
      navigate(`/admin/product/update/${id}`);
    }
    handleClose();
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: "20ch",
            },
          },
        }}
      >
        {options?.map((option) => (
          <MenuItem
            key={option.value}
            data-my-value={option.value}
            onClick={(e) => handleActionClick(e, item._id)}
          >
            {option.title}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default MenuItems;
